/**
 * Centralized product slider helper - manages wrapper height and slide accessibility
 * Used by homepage collection sliders and product page related products
 */
var productSliderHelper = {
    desktopBreakpoint: 768,

    // Common swiper configuration for product sliders
    getCommonConfig: function () {
        return {
            ally: {
                enable: true,
                prevSlideMessage: 'Previous products',
                nextSlideMessage: 'Next products',
            },
            keyboard: true,
            slidesPerView: 2.5,
            spaceBetween: 8,
            allowTouchMove: true,
            freeMode: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                dragClass: 'swiper-scrollbar-drag',
                dragSize: 200
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    spaceBetween: 20,
                    slidesPerView: 3.5,
                }
            }
        };
    },

    // Initialize a product slider with common setup
    initSlider: function (element, swiperSelector, customConfig = {}) {
        const config = { ...this.getCommonConfig(element), ...customConfig };
        return new Swiper(element.querySelector(swiperSelector), config);
    }
};
